import { Link } from "react-router-dom";
import { Car } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-obsidian text-white/70 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-sm bg-white/10 flex items-center justify-center">
              <Car className="w-5 h-5 text-blaze" />
            </span>
            <span className="font-heading font-800 text-xl text-white">Pic<span className="text-blaze">Car</span></span>
          </div>
          <p className="max-w-sm text-sm leading-relaxed">
            Anuncie seu carro de graça. Pague só quando quiser o Kit de Divulgação com QR — cartaz, cartão postal e cartão de visita com o QR Code exclusivo do seu anúncio.
          </p>
        </div>
        <div>
          <p className="overline text-white/40 mb-4">Plataforma</p>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/buscar" className="hover:text-blaze transition-colors">Buscar Carros</Link>
            <Link to="/anunciar" className="hover:text-blaze transition-colors">Anunciar Grátis</Link>
            <Link to="/materiais" className="hover:text-blaze transition-colors" data-testid="footer-materiais">Kit de Divulgação com QR</Link>
            <Link to="/precos" className="hover:text-blaze transition-colors">Preços</Link>
            <Link to="/como-funciona" className="hover:text-blaze transition-colors">Como Funciona</Link>
          </div>
        </div>
        <div>
          <p className="overline text-white/40 mb-4">Conta</p>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/entrar" className="hover:text-blaze transition-colors">Entrar</Link>
            <Link to="/painel" className="hover:text-blaze transition-colors">Meus Anúncios</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} PicCar · piccar.com.br — Todos os direitos reservados
      </div>
    </footer>
  );
}
